/* =============================================================================
   FLIPSIDE RECORDS — tema
   Carrito por AJAX, fragmentos de escucha y Radio Flipside.
   ============================================================================= */
var $ = function(s){ return document.querySelector(s); };

/* ---------- Utilidades ---------- */
var tToast;
function toast(msg){
  var t = $('#toast');
  t.textContent = msg; t.classList.add('show');
  clearTimeout(tToast); tToast = setTimeout(function(){ t.classList.remove('show'); }, 2400);
}
function dinero(centavos){
  var f = (window.FLIPSIDE && FLIPSIDE.moneyFormat) || '${{amount}}';
  var n = (centavos / 100).toLocaleString('es-MX', {minimumFractionDigits:0, maximumFractionDigits:0});
  return f.replace(/\{\{\s*amount[^}]*\}\}/, n);
}

/* ---------- Menú discreto ---------- */
function toggleMas(e){ e.stopPropagation(); $('#masMenu').classList.toggle('open'); }
document.addEventListener('click', function(){
  var m = $('#masMenu'); if(m) m.classList.remove('open');
});

/* ---------- Carrito ---------- */
var UMBRAL_ENVIO_GRATIS = 150000; /* $1,500.00 MXN en centavos */
function actualizarEnvioGratis(total){
  var caja = document.getElementById('envioBarra');
  if(!caja) return;
  if(!total){ caja.style.display = 'none'; return; }
  caja.style.display = 'block';
  var falta = UMBRAL_ENVIO_GRATIS - total;
  var pct = Math.min(100, Math.round(total * 100 / UMBRAL_ENVIO_GRATIS));
  document.getElementById('envioFill').style.width = pct + '%';
  document.getElementById('envioTexto').innerHTML = falta > 0
    ? 'Te faltan <strong>' + dinero(falta) + '</strong> para envío gratis'
    : 'Tu pedido tiene <strong>envío gratis</strong> 🎉';
}
function abrirCarrito(){
  $('#cajon').classList.add('open'); $('#overlay').classList.add('open');
  refrescarCarrito();
}
function cerrarCarrito(){
  $('#cajon').classList.remove('open'); $('#overlay').classList.remove('open');
}
function agregarAlCarrito(btn){
  var id = btn.dataset.variante;
  if(!id) return;
  btn.disabled = true;
  fetch(FLIPSIDE.rutas.agregar, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
  })
  .then(function(r){ return r.json(); })
  .then(function(res){
    btn.disabled = false;
    if(res.status){ toast(res.description || 'No pude agregarlo'); return; }
    var texto = btn.textContent;
    btn.textContent = 'Agregado'; btn.classList.add('listo');
    setTimeout(function(){ btn.textContent = texto; btn.classList.remove('listo'); }, 1200);
    refrescarCarrito(true);
  })
  .catch(function(){ btn.disabled = false; toast('No pude agregarlo'); });
}
function cambiarLinea(linea, cantidad){
  fetch(FLIPSIDE.rutas.cambiar, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ line: linea, quantity: cantidad })
  }).then(function(r){ return r.json(); }).then(function(){ refrescarCarrito(); });
}
function refrescarCarrito(abrir){
  fetch(FLIPSIDE.rutas.carrito).then(function(r){ return r.json(); }).then(function(c){
    $('#cartCount').textContent = c.item_count;
    $('#cajonTotal').textContent = dinero(c.total_price);
    actualizarEnvioGratis(c.total_price);
    if(!c.items.length){
      $('#cajonBody').innerHTML = '<div class="vacio">Tu carrito está vacío.<br>Los buenos discos no se compran solos.</div>';
    } else {
      $('#cajonBody').innerHTML = c.items.map(function(it, i){
        return '<div class="ci">' +
          '<span class="ci-cov" style="background-image:url(' + (it.image || '') + ')"></span>' +
          '<div class="ci-main">' +
            '<span class="a">' + (it.vendor || '') + '</span>' +
            '<a href="' + it.url + '"><span class="t">' + it.product_title + '</span></a>' +
            '<div class="qty">' +
              '<button onclick="cambiarLinea(' + (i+1) + ',' + (it.quantity-1) + ')">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button onclick="cambiarLinea(' + (i+1) + ',' + (it.quantity+1) + ')">+</button>' +
            '</div>' +
          '</div>' +
          '<span class="precio">' + dinero(it.final_line_price) + '</span>' +
        '</div>';
      }).join('');
    }
    if(abrir) abrirCarrito();
  });
}

/* ---------- Filtros del catálogo ---------- */
var filtros = { genero:'', condicion:'', formato:'', precio:'' };
function precioOk(p){
  if(!filtros.precio) return true;
  var partes = filtros.precio.split('-');
  var v = Number(p || 0), min = Number(partes[0] || 0);
  var max = partes[1] ? Number(partes[1]) : Infinity;
  return v >= min && v < max;
}
function filtrar(btn){
  filtros[btn.dataset.tipo] = btn.dataset.valor;
  document.querySelectorAll('.chip[data-tipo="' + btn.dataset.tipo + '"]').forEach(function(c){
    c.classList.toggle('active', c === btn);
  });
  var visibles = 0;
  document.querySelectorAll('#catalogo .disco').forEach(function(d){
    var ok = (!filtros.genero || d.dataset.genero === filtros.genero) &&
             (!filtros.condicion || d.dataset.condicion === filtros.condicion) &&
             (!filtros.formato || d.dataset.formato === filtros.formato) &&
             precioOk(d.dataset.precio);
    d.classList.toggle('oculto', !ok);
    if(ok) visibles++;
  });
  var aviso = $('#sinResultados');
  if(aviso) aviso.style.display = visibles ? 'none' : 'block';
}

/* ---------- Fragmentos de escucha ---------- */
var fragAudio = null, fragBtn = null, radioPausadaPorFragmento = false;
function reproducirFragmento(btn){
  if(fragBtn === btn && fragAudio && !fragAudio.paused){ pausarFragmento(); return; }
  if(fragAudio){ fragAudio.pause(); fragAudio = null; }
  if(radioAudio && !radioAudio.paused){
    radioAudio.pause(); radioPausadaPorFragmento = true; $('#rcPlay').textContent = '▶';
  }
  fragBtn = btn;
  fragAudio = new Audio(btn.dataset.audio);
  fragAudio.play().catch(function(){ toast('No pude cargar el audio'); });

  fragAudio.addEventListener('timeupdate', function(){
    if(!fragAudio) return;
    var tope = FLIPSIDE.previewSegundos;
    if(fragAudio.currentTime >= tope){ pararFragmento(); return; }
    $('#plFill').style.width = (fragAudio.currentTime / tope * 100) + '%';
    var resta = Math.max(0, Math.round(tope - fragAudio.currentTime));
    $('#plTime').textContent = Math.floor(resta/60) + ':' + String(resta%60).padStart(2,'0');
  });
  fragAudio.addEventListener('ended', pararFragmento);
  fragAudio.addEventListener('error', function(){ toast('No encuentro el archivo de audio'); pararFragmento(); });

  $('#plCov').style.backgroundImage = 'url(' + (btn.dataset.img || '') + ')';
  $('#plTitulo').textContent = btn.dataset.titulo;
  $('#plToggle').textContent = '❚❚';
  $('#player').classList.add('on');
  marcarBotones();
}
function pausarFragmento(){
  if(!fragAudio) return;
  if(fragAudio.paused){ fragAudio.play(); $('#plToggle').textContent = '❚❚'; }
  else { fragAudio.pause(); $('#plToggle').textContent = '▶'; }
  marcarBotones();
}
function pararFragmento(){
  if(fragAudio){ fragAudio.pause(); fragAudio = null; }
  fragBtn = null;
  $('#player').classList.remove('on');
  $('#plFill').style.width = '0';
  marcarBotones();
  if(radioPausadaPorFragmento && radioAudio){ radioAudio.play(); $('#rcPlay').textContent = '❚❚'; }
  radioPausadaPorFragmento = false;
}
function marcarBotones(){
  document.querySelectorAll('.cover-play').forEach(function(b){
    b.classList.toggle('sonando', b === fragBtn && fragAudio && !fragAudio.paused);
  });
}

/* =============================================================================
   RADIO FLIPSIDE
   Dos modos:
   1) MEZCLA: un solo archivo largo + lista con tiempos. La tarjeta cambia sola
      conforme avanza la mezcla y siempre apunta al disco que está sonando.
   2) FRAGMENTOS: si no hay mezcla, arma una radio en aleatorio con los
      fragmentos sueltos de cada disco.
   ============================================================================= */
var radioAudio = null, radioEncendida = false, radioModo = 'fragmentos';
var radioCues = [], radioCueIdx = -1;
var radioCola = [], radioIdx = 0, radioLista = [];

function segundos(txt){
  var p = txt.trim().split(':').map(Number);
  if(p.some(isNaN)) return null;
  if(p.length === 3) return p[0]*3600 + p[1]*60 + p[2];
  if(p.length === 2) return p[0]*60 + p[1];
  return p[0];
}
function reloj(s){
  s = Math.max(0, Math.floor(s));
  var h = Math.floor(s/3600), m = Math.floor((s%3600)/60), g = s%60;
  return (h ? h + ':' + String(m).padStart(2,'0') : m) + ':' + String(g).padStart(2,'0');
}

/* Lee la lista con tiempos y la cruza con el catálogo */
function armarCues(){
  var R = window.RADIO || {};
  if(!R.listado) return [];
  return R.listado.split('\n').map(function(linea){
    if(!linea.trim()) return null;
    var partes = linea.split('|').map(function(x){ return x.trim(); });
    if(partes.length < 2) return null;
    var t = segundos(partes[0]);
    if(t === null) return null;
    var handle = partes[1].replace(/^\/+|\/+$/g,'').split('/').pop();
    var prod = (R.catalogo || {})[handle];
    if(!prod) return null;
    return {
      inicio: t,
      cancion: partes[2] || prod.cancion || prod.titulo,
      titulo: prod.titulo, vendor: prod.vendor, url: prod.url, img: prod.img,
      precio: prod.precio, variante: prod.variante, disponible: prod.disponible
    };
  }).filter(Boolean).sort(function(a,b){ return a.inicio - b.inicio; });
}
function armarFragmentos(){
  var cat = (window.RADIO || {}).catalogo || {};
  return Object.keys(cat).map(function(h){ return cat[h]; })
    .filter(function(p){ return p.audio; })
    .map(function(p){ return { cancion: p.cancion, titulo: p.titulo, vendor: p.vendor, url: p.url,
                               img: p.img, precio: p.precio, variante: p.variante,
                               disponible: p.disponible, audio: p.audio }; });
}
function revolver(a){
  var c = a.slice();
  for(var i = c.length - 1; i > 0; i--){
    var j = Math.floor(Math.random() * (i + 1));
    var t = c[i]; c[i] = c[j]; c[j] = t;
  }
  return c;
}

function encenderRadio(){
  var R = window.RADIO || {};
  if(fragAudio) pararFragmento();

  if(R.mezcla && radioCues.length){
    radioModo = 'mezcla';
    if(radioAudio){ radioAudio.pause(); radioAudio = null; }
    radioAudio = new Audio(R.mezcla);
    radioAudio.preload = 'metadata';
    radioAudio.addEventListener('timeupdate', vigilarMezcla);
    radioAudio.addEventListener('error', function(){ toast('No pude cargar la mezcla'); apagarRadio(); });
    radioAudio.addEventListener('ended', function(){ radioAudio.currentTime = 0; radioAudio.play(); });
    var arranque = 0;
    if(R.alAzar && radioCues.length > 1){
      arranque = radioCues[Math.floor(Math.random() * radioCues.length)].inicio;
    }
    radioCueIdx = -1;
    var irAlPunto = function(){ radioAudio.currentTime = arranque; vigilarMezcla(); };
    if(radioAudio.readyState > 0) irAlPunto();
    else radioAudio.addEventListener('loadedmetadata', irAlPunto, { once: true });
    radioAudio.play().catch(function(){ toast('Toca otra vez para iniciar la radio'); });
    radioEncendida = true;
    $('#radioCard').classList.add('on');
    document.querySelector('#btnRadio').textContent = 'Radio encendida';
    return;
  }

  /* respaldo: fragmentos sueltos en aleatorio */
  radioModo = 'fragmentos';
  radioLista = armarFragmentos();
  if(!radioLista.length){ toast('Todavía no hay música cargada en la radio'); return; }
  radioCola = revolver(radioLista); radioIdx = 0; radioEncendida = true;
  $('#radioCard').classList.add('on');
  sonarFragmentoRadio();
}

/* --- modo mezcla --- */
function cueActual(t){
  var idx = -1;
  for(var i = 0; i < radioCues.length; i++){
    if(radioCues[i].inicio <= t) idx = i; else break;
  }
  return idx;
}
function vigilarMezcla(){
  if(!radioAudio) return;
  var t = radioAudio.currentTime;
  var idx = cueActual(t);
  if(idx !== radioCueIdx){
    radioCueIdx = idx;
    pintarTarjeta(radioCues[idx] || null);
    marcarPrograma();
  }
  var cue = radioCues[radioCueIdx];
  if(cue){
    var sig = radioCues[radioCueIdx + 1];
    var fin = sig ? sig.inicio : (radioAudio.duration || cue.inicio + 300);
    var avance = (t - cue.inicio) / Math.max(1, fin - cue.inicio);
    $('#rcFill').style.width = Math.min(100, avance * 100) + '%';
  }
}
function pintarTarjeta(t){
  if(!t){
    $('#rcCancion').textContent = 'Radio Flipside';
    $('#rcDisco').textContent = 'Mezcla continua';
    $('#rcPrecio').textContent = '';
    $('#rcComprar').disabled = true;
    return;
  }
  $('#rcCov').style.backgroundImage = 'url(' + (t.img || '') + ')';
  $('#rcCancion').textContent = t.cancion;
  $('#rcDisco').textContent = t.vendor + ' · ' + t.titulo;
  $('#rcPrecio').textContent = t.disponible ? t.precio : 'Agotado';
  $('#rcComprar').textContent = t.disponible ? 'Agregar' : 'Agotado';
  $('#rcComprar').disabled = !t.disponible;
  $('#rcPlay').textContent = '❚❚';
}

/* --- modo fragmentos --- */
function sonarFragmentoRadio(){
  var t = radioCola[radioIdx];
  if(radioAudio){ radioAudio.pause(); radioAudio = null; }
  radioAudio = new Audio(t.audio);
  radioAudio.play().catch(function(){ toast('No pude cargar esa canción'); });
  radioAudio.addEventListener('timeupdate', function(){
    if(!radioAudio || !radioAudio.duration) return;
    $('#rcFill').style.width = (radioAudio.currentTime / radioAudio.duration * 100) + '%';
  });
  radioAudio.addEventListener('ended', radioSiguiente);
  radioAudio.addEventListener('error', function(){ toast('Salté una canción que no cargó'); radioSiguiente(); });
  pintarTarjeta(t);
  var b = $('#btnRadio'); if(b) b.textContent = 'Radio encendida';
}

/* --- controles comunes --- */
function radioSiguiente(){
  if(!radioEncendida) return;
  if(radioModo === 'mezcla'){
    var sig = radioCues[radioCueIdx + 1];
    radioAudio.currentTime = sig ? sig.inicio : 0;
    vigilarMezcla();
    return;
  }
  radioIdx++;
  if(radioIdx >= radioCola.length){ radioCola = revolver(radioLista); radioIdx = 0; }
  sonarFragmentoRadio();
}
function radioAnterior(){
  if(!radioEncendida || radioModo !== 'mezcla') return;
  var cue = radioCues[radioCueIdx];
  /* si ya avanzaste más de 5 s, regresa al inicio de la canción actual */
  var destino = (cue && radioAudio.currentTime - cue.inicio > 5)
    ? cue.inicio
    : (radioCues[radioCueIdx - 1] || radioCues[0]).inicio;
  radioAudio.currentTime = destino;
  vigilarMezcla();
}
function irACancion(i){
  if(!radioEncendida) encenderRadio();
  if(radioModo !== 'mezcla' || !radioAudio) return;
  radioAudio.currentTime = radioCues[i].inicio;
  radioAudio.play();
  vigilarMezcla();
}
function radioPausa(){
  if(!radioAudio) return;
  if(radioAudio.paused){ radioAudio.play(); $('#rcPlay').textContent = '❚❚'; }
  else { radioAudio.pause(); $('#rcPlay').textContent = '▶'; }
}
function apagarRadio(){
  if(radioAudio){ radioAudio.pause(); radioAudio = null; }
  radioEncendida = false; radioCueIdx = -1;
  $('#radioCard').classList.remove('on');
  $('#rcFill').style.width = '0';
  marcarPrograma();
  var b = $('#btnRadio'); if(b) b.textContent = 'Encender la radio';
}
function pistaActual(){
  return radioModo === 'mezcla' ? radioCues[radioCueIdx] : radioCola[radioIdx];
}
function radioAgregar(){
  var t = pistaActual();
  if(!t || !t.disponible) return;
  fetch(FLIPSIDE.rutas.agregar, {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ items: [{ id: t.variante, quantity: 1 }] })
  }).then(function(r){ return r.json(); }).then(function(){
    toast(t.titulo + ' se agregó al carrito');
    refrescarCarrito();
  });
}
function radioVerDisco(){ var t = pistaActual(); if(t) window.location.href = t.url; }

/* --- lista de canciones bajo el reproductor --- */
var PROGRAMA_VISIBLES = 5;
function pintarPrograma(){
  var cont = $('#programa');
  if(!cont || !radioCues.length) return;
  cont.innerHTML = '<div class="programa-titulo">Lo que suena en esta mezcla</div>' +
    radioCues.map(function(t, i){
      var extra = i >= PROGRAMA_VISIBLES ? ' oculta' : '';
      return '<div class="pista' + extra + '" id="pista-' + i + '" onclick="irACancion(' + i + ')">' +
        '<span class="pista-t">' + reloj(t.inicio) + '</span>' +
        '<span class="pista-cov" style="background-image:url(' + (t.img || '') + ')"></span>' +
        '<span class="pista-info"><strong>' + t.cancion + '</strong>' +
          '<small>' + t.vendor + ' · ' + t.titulo + '</small></span>' +
        '<span class="pista-precio">' + (t.disponible ? t.precio : 'Agotado') + '</span>' +
        '<a class="pista-ir" href="' + t.url + '" onclick="event.stopPropagation()">Ver disco</a>' +
      '</div>';
    }).join('') +
    (radioCues.length > PROGRAMA_VISIBLES
      ? '<div class="programa-mas"><button class="btn btn-ghost" id="btnPrograma" onclick="alternarPrograma()">Ver las ' + radioCues.length + ' canciones</button></div>'
      : '');
}
function alternarPrograma(){
  var cont = $('#programa'), b = $('#btnPrograma');
  if(!cont) return;
  var abierto = cont.classList.toggle('abierto');
  if(b) b.textContent = abierto ? 'Ver menos' : 'Ver las ' + radioCues.length + ' canciones';
  if(!abierto) cont.scrollIntoView({behavior:'smooth', block:'start'});
}
function marcarPrograma(){
  document.querySelectorAll('.pista').forEach(function(p, i){
    var sonando = radioEncendida && radioModo === 'mezcla' && i === radioCueIdx;
    p.classList.toggle('sonando', sonando);
    if(sonando && p.classList.contains('oculta')){
      var cont = $('#programa'), b = $('#btnPrograma');
      if(cont && !cont.classList.contains('abierto')){
        cont.classList.add('abierto');
        if(b) b.textContent = 'Ver menos';
      }
    }
  });
}

/* ---------- Arranque ---------- */
document.addEventListener('DOMContentLoaded', function(){
  radioCues = armarCues();
  pintarPrograma();
  var n = $('#radioNum');
  if(n) n.textContent = radioCues.length || armarFragmentos().length;
  document.querySelectorAll('#navLinks a').forEach(function(a){
    a.addEventListener('click', function(){ $('#navLinks').classList.remove('open'); });
  });
  refrescarCarrito();
});
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') cerrarCarrito(); });
